export default {
  FOCUS: 'FOCUS_GRAPH_ENTITY',
  UNFOCUS: 'UNFOCUS_GRAPH',
  PREVIOUS_NEIGHBORHOODS: {
    CAPTURE: 'CAPTURE_PREVIOUS_NEIGHBORHOODS',
    REMOVE: 'REMOVE_PREVIOUS_NEIGHBORHOOD'
  },
  GET_NEIGHBORHOOD: {
    REQUEST: 'REQUEST_GET_NEIGHBORHOOD',
    RECEIVE: 'RECEIVE_GET_NEIGHBORHOOD',
    FAIL: 'FAIL_GET_NEIGHBORHOOD'
  },
  SELECTED: {
    DESELECT_ALL: 'DESELECT_ALL',
    TOGGLE_SELECT_ALL: 'TOGGLE_SELECT_ALL'
  },
  DRAG: {
    START: 'START_DRAGGING',
    STOP: 'STOP_DRAGGING'
  },
  EDGE_CREATION: {
    START: 'START_CREATING_EDGE',
    STOP: 'STOP_CREATING_EDGE'
  },
  OBJECT_DETAILS: {
    OPEN: 'OPEN_OBJECT_DETAILS',
    CLOSE: 'CLOSE_OBJECT_DETAILS'
  },
  EDIT: {
    START: 'START_EDITING',
    STOP: 'STOP_EDITING'
  },
  CULLING: {
    SET_DEPTH: 'SET_CULLING_DEPTH',
    RESET_DEPTH: 'RESET_CULLING_DEPTH',
    INCREASE_DEPTH: 'INCREASE_CULLING_DEPTH',
    DECREASE_DEPTH: 'DECREASE_CULLING_DEPTH'
  }
}
